<template>
  <div class="match-invite-page">
    <Breadcrumb :type="1"></Breadcrumb>
    <div class="faculty-content">
      <img src="@/assets/images/icon-24.png" alt="" class="icon-image" />
      <div class="faculty-list">
        <div class="list-flex" v-for="(item, index) in newsList" :key="index">
          <div class="flex-avatar">
            <img :src="item.avatarUrl" alt="" class="image" />
          </div>
          <div class="flex-contain">
            <div class="name">{{ item.teacherName }}</div>
            <div class="title">
              {{ item.title }}
              <div class="hr"></div>
            </div>
            <div class="message" :title="item.description || '--'">
              {{ item.description || '--' }}
            </div>
          </div>
        </div>
      </div>
      <Pagination
        :pageSize="pageSize"
        :pageCount="pageCount"
        @changePageClick="changePageClick"
        v-if="newsList.length > 0"
      ></Pagination>
      <el-empty description="暂无数据" v-if="newsList.length == 0"></el-empty>
    </div>
  </div>
</template>

<script>
import { getTeacherPage } from '@/api/home/home.js'
import Breadcrumb from '@/components/common/breadcrumb'
import Pagination from '@/components/common/Pagination.vue'
export default {
  components: {
    Breadcrumb,
    Pagination
  },
  data() {
    return {
      categoryId: '',
      tabcode: '',
      pageSize: 12, //分页数量
      pageCount: 0, //列表总数
      newsList: []
    }
  },
  created() {
    this.categoryId = this.$route.query?.categoryId
    this.tabcode = this.$route.query?.tabcode
    this.getArticlePage()
  },
  methods: {
    //获取师资队伍
    getArticlePage(page = 1) {
      getTeacherPage({
        page: page,
        limit: this.pageSize
      }).then((res) => {
        if (!res.data) return
        this.newsList = res.data.list
        this.pageCount = Number(res.data.count)
      })
    },
    //切换页面
    changePageClick(page) {
      this.getArticlePage(page)
    }
  }
}
</script>

<style scoped lang="scss">
.match-invite-page {
  display: flex;
  flex-direction: column;
  .faculty-content {
    display: flex;
    flex-direction: column;
    width: 1472px;
    margin: 34px auto 120px;
    .faculty-list {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      margin-top: 10px;
      .list-flex {
        width: 352px;
        height: 218px;
        display: flex;
        flex-direction: row;
        margin-right: 16px;
        margin-top: 38px;
        .flex-contain {
          display: flex;
          flex-direction: column;
          width: 252px;
          height: 206px;
          box-sizing: border-box;
          padding: 14px 24px 16px 44px;
          border: 1px solid rgba(230, 230, 230, 0.6);
          background: #f8f8f9;
          position: relative;
          top: 10px;
          margin-left: -36px;
          .message {
            width: 174px;
            height: 100px;
            line-height: 20px;
            font-size: 14px;
            color: #333;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 5;
            -webkit-box-orient: vertical;
            margin-top: 8px;
            margin-left: auto;
            text-align: justify;
            word-break: break-all;
          }
          .title {
            height: 28px;
            line-height: 28px;
            color: #1b56a9;
            font-size: 18px;
            text-align: right;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            margin-top: 6px;
            position: relative;
            .hr {
              bottom: 0;
              position: absolute;
              right: 0;
              background: #1b56a9;
              width: 60px;
              height: 1px;
            }
          }
          .name {
            height: 34px;
            line-height: 34px;
            color: #111;
            font-size: 24px;
            text-align: right;
            font-weight: bold;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
          }
        }
        .flex-avatar {
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          background: #f1f1f3;
          width: 136px;
          height: 208px;
          position: relative;
          bottom: 10px;
          z-index: 2;
          .image {
            width: 128px;
            height: 163px;
            object-fit: contain;
            margin: auto auto 0;
          }
        }
      }
    }
    .icon-image {
      width: 250px;
      height: 64px;
      margin: 0 auto 34px;
      object-fit: cover;
    }
  }
}

// 手机端css
.mobile-content {
  .match-invite-page {
    .faculty-content {
      width: 345px;
      margin: 20px auto 60px;
      .faculty-list {
        margin-top: 8px;
        flex-direction: column;
        .list-flex {
          width: 345px;
          height: 180px;
          margin-right: 0;
          margin-top: 20px;
          .flex-contain {
            width: 100%;
            height: 175px;
            top: 5px;
            padding: 10px 12px 8px 30px;
            margin-left: -20px;
            .message {
              width: 100%;
              margin-top: 6px;
              font-size: 12px;
              line-height: 18px;
              height: 90px;
            }
            .title {
              height: 22px;
              line-height: 22px;
              font-size: 14px;
              margin-top: 4px;
              .hr {
                width: 40px;
              }
            }
            .name {
              height: 28px;
              line-height: 28px;
              font-size: 20px;
            }
          }
          .flex-avatar {
            width: 100px;
            height: 175px;
            bottom: 5px;
            .image {
              width: 94px;
              height: 150px;
            }
          }
        }
      }
      .icon-image {
        width: 150px;
        height: 38.4px;
      }
    }
  }
}
</style>
